var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Watch } from 'vue-property-decorator';
import { HiredPerson } from '@/common/types/HiredPerson';
import AidApplicationBase from '@/template/views/AidApplicationBase';
import TextAreaRow from '@/common/components/TextAreaRow.vue';
import RadioButtonRow from '@/common/components/RadioButtonRow.vue';
import CheckBoxListRow from '@/common/components/CheckBoxListRow.vue';
import DateInputRow from '@/common/components/DateInputRow.vue';
import SingleSelectAccessible from '@/common/components/SingleSelectAccessible.vue';
import { parseString, absoluteMinimumDate, absoluteMaximumDate, reasonableMinimumDate, reasonableMaximumDate } from '@/common/utils/dateUtilities';
import { isNullOrUndefined } from 'util';
var BasicInfoView = /** @class */ (function (_super) {
    __extends(BasicInfoView, _super);
    function BasicInfoView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.checkBoxValueChanged = "checkbox";
        _this.radioButtonValueChanged = "radio";
        _this.hiredPersonOptions = [
            { id: HiredPerson.PartiallyDisabled, name: "AidApplication.BasicInfo.PlaceOpen.HiredPerson.PartiallyDisabled" },
            { id: HiredPerson.Young, name: "AidApplication.BasicInfo.PlaceOpen.HiredPerson.Young" }
        ];
        return _this;
    }
    Object.defineProperty(BasicInfoView.prototype, "showDescriptionForPartialDisabled", {
        get: function () {
            return this.aidapplication.basicInfo.placeOpen.hiredPerson.includes(HiredPerson.PartiallyDisabled);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicInfoView.prototype, "showApprenticeshipsDescription", {
        get: function () {
            return this.aidapplication.basicInfo.placeOpen.isApprenticeships;
        },
        enumerable: false,
        configurable: true
    });
    BasicInfoView.prototype.onHiredPersonChanged = function (newValue, oldValue) {
        if (oldValue.includes(HiredPerson.PartiallyDisabled) && !newValue.includes(HiredPerson.PartiallyDisabled)) {
            var desc = this.aidapplication.basicInfo.placeOpen.howPartialDisabilityIsNoticed;
            if (!isNullOrUndefined(desc) && desc.trim().length > 0) {
                if (confirm(this.$i18n.t("AidApplication.Confirm.Delete.HiredPerson").toString())) {
                    this.aidapplication.basicInfo.placeOpen.howPartialDisabilityIsNoticed = null;
                }
                else {
                    this.aidapplication.basicInfo.placeOpen.hiredPerson.push(HiredPerson.PartiallyDisabled);
                    this.checkBoxValueChanged = Date();
                }
            }
        }
    };
    BasicInfoView.prototype.onIsApprenticeshipsChanged = function () {
        var _a;
        if (!this.showApprenticeshipsDescription && ((_a = this.aidapplication.basicInfo.placeOpen.apprenticeshipsDescription) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            if (confirm(this.$i18n.t("AidApplication.Confirm.Delete.Apprenticeship").toString())) {
                this.aidapplication.basicInfo.placeOpen.apprenticeshipsDescription = null;
            }
            else {
                this.aidapplication.basicInfo.placeOpen.isApprenticeships = true;
                this.radioButtonValueChanged = Date();
            }
        }
    };
    Object.defineProperty(BasicInfoView.prototype, "startTimeRules", {
        get: function () {
            var minDate = parseString(this.isExtension
                ? absoluteMinimumDate
                : reasonableMinimumDate(this.aidapplication.applicationYear));
            var maxDate = parseString(reasonableMaximumDate(this.aidapplication.applicationYear));
            return {
                earlierStr: '@AidApplication.BasicInfo.PlaceOpen.EndTime',
                within: [minDate, maxDate]
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicInfoView.prototype, "endTimeRules", {
        get: function () {
            var maxDate = parseString(absoluteMaximumDate);
            return {
                laterStr: '@AidApplication.BasicInfo.PlaceOpen.StartTime',
                within: [null, maxDate]
            };
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Watch("aidapplication.basicInfo.placeOpen.hiredPerson"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array, Array]),
        __metadata("design:returntype", void 0)
    ], BasicInfoView.prototype, "onHiredPersonChanged", null);
    __decorate([
        Watch("aidapplication.basicInfo.placeOpen.isApprenticeships"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], BasicInfoView.prototype, "onIsApprenticeshipsChanged", null);
    BasicInfoView = __decorate([
        Component({
            name: "BasicInfoView",
            components: {
                RadioButtonRow: RadioButtonRow,
                CheckBoxListRow: CheckBoxListRow,
                TextAreaRow: TextAreaRow,
                DateInputRow: DateInputRow,
                SingleSelectAccessible: SingleSelectAccessible
            }
        })
    ], BasicInfoView);
    return BasicInfoView;
}(AidApplicationBase));
export default BasicInfoView;
